import { CustomFormFieldBase } from "./custom-form-field.type";

export class DropdownFormControl extends CustomFormFieldBase<string> {
    override controlType = 'dropdown'; 
}
